import { IMouseEvent } from "../../../base/browser/mouseEvent";
import { Event } from "../../../base/common/events";
import { createDecorator } from "../../instantiation/common/registry";


export const IPointerService = createDecorator<IPointerService>('pointerService');

export interface IPointerService {


    readonly _serviceBrand: undefined;

    readonly onMouseDown: Event<IMouseEvent>;
    readonly onMouseMove: Event<IMouseEvent>;
    readonly onMouseUp: Event<IMouseEvent>;
    readonly onMouseCancel: Event<IMouseEvent>;
}
